import * as React from 'react'

import withCms from 'cms/with-cms'
import withLayout from 'cms/with-layout'

import type { NextPage } from '@grandvisionhq/next'
import { withScridId } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'
import { InitialProps, Page, Props } from '@grandvisionhq/www-next/pages/returns'

import '@grandvisionhq/fun-returns/dist/index.css'

const ReturnsPage: NextPage<Props, InitialProps> = (props) => <Page {...props} />

ReturnsPage.getInitialProps = Page.getInitialProps

export default compose(withCms(), withLayout(), withScridId())(ReturnsPage)
